import { render, staticRenderFns } from "./sealBox.vue?vue&type=template&id=89b78d40&scoped=true"
import script from "./sealBox.vue?vue&type=script&lang=js"
export * from "./sealBox.vue?vue&type=script&lang=js"
import style0 from "./sealBox.vue?vue&type=style&index=0&id=89b78d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b78d40",
  null
  
)

export default component.exports